var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "scroll-horizontal",
      class: ((_obj = {}),
      (_obj["scroll-horizontal--offset-" + _vm.offset] = _vm.offset !== ""),
      (_obj["scroll-horizontal--padding-" + _vm.padding] = _vm.padding !== ""),
      (_obj["scroll-horizontal--" + _vm.paddingColor] =
        _vm.paddingColor !== ""),
      (_obj["scroll-horizontal--" + _vm.activeOn] = _vm.activeOn !== ""),
      _obj)
    },
    [
      _c(
        "div",
        { staticClass: "scroll-horizontal__inner" },
        [_vm._t("default")],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }